import { render, staticRenderFns } from "./NR1Observations.vue?vue&type=template&id=e1b6b32c&scoped=true&"
import script from "./NR1Observations.vue?vue&type=script&lang=js&"
export * from "./NR1Observations.vue?vue&type=script&lang=js&"
import style0 from "./NR1Observations.vue?vue&type=style&index=0&id=e1b6b32c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b6b32c",
  null
  
)

export default component.exports